module.exports = __webpack_public_path__ + "img/Flow_kuraray_JP@3x.4d37af68.png";